module.exports = __webpack_public_path__ + "static/img/add_family_member.9980a99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/add_family_member.jpg
// module id = vPjn
// module chunks = 7